const translations: Record<string, string> = {
  "ak_scada_normal": "Норма",
  "ak_scada_warning": "Попередження",
  "ak_scada_alarm": "Аварія",
  "ak_scada_no_link": "Немає звʼязку",
  "ak_scada_curtailed": "Обмеження",
  "ak_scada_planned_maintenance": "Планові роботи",
  "ak_scada_commissioning": "Введення",
  "ak_scada_collector_cycle_1_min": "цикл колектора ~1 хв",
  "ak_scada_collector_cycle_5_min": "цикл колектора ~5 хв",
  "ak_scada_no_data": "немає даних",
  "ak_scada_s_ago": "{{n}} с тому",
  "ak_scada_min_ago": "{{n}} хв тому",
  "ak_scada_h_min_ago": "{{h}} год {{m}} хв тому",
  "ak_scada_d_ago": "{{n}} дн тому",
  "ak_scada_online": "на звʼязку",
  "ak_scada_data_is_getting_stale": "дані застарівають",
  "ak_scada_no_link_2": "немає звʼязку",
  "ak_scada_data_quality": "Якість даних: {{q}}",
  "ak_scada_active_power": "Активна потужність",
  "ak_scada_mw": "МВт",
  "ak_scada_kw": "кВт",
  "ak_scada_current": "Поточне",
  "ak_scada_new": "Нове",
  "ak_scada_cancel": "Скасувати",
  "ak_scada_confirm_and_execute": "Підтвердити і виконати",
  "ak_scada_soon": "Скоро",
  "ak_scada_section_under_preparation": "Розділ у підготовці",
  "ak_scada_dc_ac_mw": "DC {{dc}} / AC {{ac}} МВт",
  "ak_scada_of_capacity": "{{p}}% потужності",
  "ak_scada_inverters_running": "Інвертори ({{w}}/{{n}} в роботі)",
  "ak_scada_charge_for_the_hour_from": "Заряд за годину · з {{h}}",
  "ak_scada_charge_for_the_hour": "Заряд за годину",
  "ak_scada_discharge_for_the_hour_from": "Розряд за годину · з {{h}}",
  "ak_scada_discharge_for_the_hour": "Розряд за годину",
  "ak_scada_station_not_found": "Станція не знайдена",
  "ak_scada_unknown_station_identifier": "Невідомий ідентифікатор станції.",
  "ak_scada_station_power": "Потужність станції",
  "ak_scada_inverters_online": "Інвертори онлайн",
  "ak_scada_generated_today": "Згенеровано сьогодні",
  "ak_scada_mwh": "МВт·год",
  "ak_scada_dc_input": "DC вхід",
  "ak_scada_commercial_metering_dlms": "Комерційний облік (DLMS)",
  "ak_scada_direct_dlms_reading_ozd": "пряме DLMS-зчитування (ОЗД)",
  "ak_scada_commercial_metering_data_is_not_availa": "Дані комерційного обліку недоступні для цієї станції",
  "ak_scada_station_single_line_diagram": "Однолінійна схема станції",
  "ak_scada_point_of_connection_ktp_inverter_group": "Точка приєднання → КТП → інверторні групи",
  "ak_scada_click_an_inverter_to_view_its_strings": "Натисніть інвертор, щоб переглянути стрінги",
  "ak_scada_bess": "УЗЕ",
  "ak_scada_storage_is_listed_in_the_asset_registr": "накопичувач є в реєстрі активів",
  "ak_scada_storage_data_is_currently_not_coming_f": "Дані накопичувача зараз не надходять із SCADA. Перевірте звʼязок з EMS BOX станції.",
  "ak_scada_this_solar_plant_has_no_energy_storage": "На цій СЕС накопичувача енергії немає.",
  "ak_scada_standby": "Очікування",
  "ak_scada_charge": "Заряд",
  "ak_scada_discharge": "Розряд",
  "ak_scada_idle": "Простій",
  "ak_scada_running": "Робота",
  "ak_scada_offline": "Офлайн",
  "ak_scada_not_charging": "Без заряду",
  "ak_scada_state_of_charge_soc": "Рівень заряду (SOC)",
  "ak_scada_storage_kehua_pcs_jinko_battery": "накопичувач · PCS Kehua + АКБ Jinko",
  "ak_scada_soc_level": "заряд SoC",
  "ak_scada_power_now": "потужність зараз",
  "ak_scada_ac_power": "Потужність AC",
  "ak_scada_available_power": "Доступна потужність",
  "ak_scada_kwh": "кВт·год",
  "ak_scada_kva": "кВА",
  "ak_scada_dc_power": "Потужність DC",
  "ak_scada_battery_voltage": "Напруга батареї",
  "ak_scada_v": "В",
  "ak_scada_battery_current": "Струм батареї",
  "ak_scada_a": "А",
  "ak_scada_frequency": "Частота",
  "ak_scada_hz": "Гц",
  "ak_scada_dc_voltage": "DC-напруга",
  "ak_scada_dc_current": "DC-струм",
  "ak_scada_temperature": "Температура",
  "ak_scada_pcs_heatsink": "Радіатор PCS",
  "ak_scada_charge_for_the_day": "Заряд за добу",
  "ak_scada_discharge_for_the_day": "Розряд за добу",
  "ak_scada_total_charged": "Всього заряджено",
  "ak_scada_total_discharged": "Всього розряджено",
  "ak_scada_available_to_charge": "Доступно зарядити",
  "ak_scada_available_to_discharge": "Доступно розрядити",
  "ak_scada_pcs_status": "Стан PCS",
  "ak_scada_bms_status": "Стан BMS",
  "ak_scada_charging": "заряд",
  "ak_scada_discharging": "розряд",
  "ak_scada_standby_2": "очікування",
  "ak_scada_fault": "аварія",
  "ak_scada_no_fresh_data": "немає свіжих даних",
  "ak_scada_estimate": "{{dir}} · оцінка",
  "ak_scada_limit_kw": "обмеження {{kw}} кВт",
  "ak_scada_active_alarms": "активних аварій: {{n}}",
  "ak_scada_mode": "режим: {{m}}",
  "ak_scada_updated": "оновлено {{a}}",
  "ak_scada_point_of_connection": "Точка приєднання",
  "ak_scada_export_to_grid": "видача в мережу",
  "ak_scada_import_from_grid": "споживання з мережі",
  "ak_scada_pv_plant": "СЕС",
  "ak_scada_inverters_online_2": "інверторів на звʼязку",
  "ak_scada_discharge_charge": "+ розряд · − заряд",
  "ak_scada_batteries_online": "батарей на звʼязку",
  "ak_scada_link": "Звʼязок",
  "ak_scada_station_status": "Стан станції",
  "ak_scada_mwh_2": "{{v}} МВт·год",
  "ak_scada_standby_3": "Очікує",
  "ak_scada_bess_storage": "УЗЕ / Накопичувач",
  "ak_scada_consolidated_bess_status": "Консолідований стан BESS",
  "ak_scada_to_charge": "Дозарядити",
  "ak_scada_to_discharge": "Розрядити",
  "ak_scada_charge_discharge_per_day": "Заряд / розряд за добу",
  "ak_scada_voltage": "Напруга",
  "ak_scada_charge_discharge_mwh": "{{d}} · заряд {{c}} / розряд {{r}} МВт·год",
  "ak_scada_no_data_for": "Немає даних за {{d}}.",
  "ak_scada_today": "Сьогодні",
  "ak_scada_for_the_current_day": "За поточну добу",
  "ak_scada_today_2": "сьогодні",
  "ak_scada_history_soc_and_power": "Історія: SoC та потужність",
  "ak_scada_history_is_not_available_for_this_stat": "Історія недоступна для цієї станції.",
  "ak_scada_loading": "Завантаження…",
  "ak_scada_power_kw": "Потужність, кВт",
  "ak_scada_time": "Час",
  "ak_scada_mode_2": "Режим",
  "ak_scada_temp_c": "Темп., °C",
  "ak_scada_off": "Вимк.",
  "ak_scada_derated": "Обмеж.",
  "ak_scada_load": "% навант.",
  "ak_scada_battery": "АКБ #{{id}}",
  "ak_scada_voltage_2": "Напруга:",
  "ak_scada_temp": "Темп:",
  "ak_scada_cells": "Комірки:",
  "ak_scada_mv": "мВ",
  "ak_scada_spread": "Розкид:",
  "ak_scada_bess_converters_kehua_pcs": "Перетворювачі УЗЕ · {{n}}× PCS Kehua",
  "ak_scada_online_2": "онлайн",
  "ak_scada_bess_batteries_jinko": "Батареї УЗЕ · {{n}}× Jinko",
  "ak_scada_available": "доступно",
  "ak_scada_power_dc_voltage_frequency_temperature": "Потужність · DC-напруга · частота · температура · навантаження по кожному PCS",
  "ak_scada_soc_soh_pack_voltage_cell_balance_temp": "SOC · SOH · напруга пакета · баланс комірок · температура по кожній батареї",
  "ak_scada_s": "{{n}}с",
  "ak_scada_min": "{{n}}хв",
  "ak_scada_h": "{{n}}год",
  "ak_scada_online_direct_dlms_reading_ozd": "{{o}}/{{c}} онлайн · пряме DLMS-зчитування (ОЗД)",
  "ak_scada_error": "Помилка: {{e}}",
  "ak_scada_updated_ago": "оновлено {{a}} тому",
  "ak_scada_offline_2": "офлайн · {{s}}",
  "ak_scada_total": "накопич.",
  "ak_scada_p_kw_today": "P {{p}} кВт · +{{g}} сьогодні · {{a}}",
  "ak_scada_import": "Імпорт",
  "ak_scada_export": "Експорт",
  "ak_scada_active_energy_export_generation": "Активна енергія, експорт (генерація)",
  "ak_scada_active_energy_import_consumption": "Активна енергія, імпорт (споживання)",
  "ak_scada_offline_3": "офлайн",
  "ak_scada_critical": "Критична",
  "ak_scada_warning_2": "Попереджувальна",
  "ak_scada_informational": "Інформаційна",
  "ak_scada_replied": " · відповів: {{n}}",
  "ak_scada_critical_2": "Критичні ({{n}})",
  "ak_scada_warnings": "Попереджувальні ({{n}})",
  "ak_scada_informational_2": "Інформаційні ({{n}})",
  "ak_scada_active": "Активні ({{n}})",
  "ak_scada_sequence_of_events": "Послідовність подій ({{n}})",
  "ak_scada_archive": "Архів ({{n}})",
  "ak_scada_open_alarms_source_generation_monitori": "{{n}} відкритих аварій · джерело: моніторинг генерації",
  "ak_scada_awaiting_response": " · очікує відповіді",
  "ak_scada_cleared": "усунено",
  "ak_scada_in_progress": "у роботі",
  "ak_scada_active_2": "активна",
  "ak_scada_all_categories": "Усі категорії",
  "ak_scada_station": "Станція",
  "ak_scada_device": "Пристрій",
  "ak_scada_category": "Категорія",
  "ak_scada_event": "Подія",
  "ak_scada_status": "Статус",
  "ak_scada_response": "Відповідь",
  "ak_scada_export_csv": "Експорт CSV",
  "ak_scada_active_events_and_alarms": "Активні події та аварії",
  "ak_scada_no_active_events": "Активних подій немає.",
  "ak_scada_sequence_of_events_chronology": "Послідовність подій (хронологія)",
  "ak_scada_all_events_for_14_days_in_chronologica": "Усі події за 14 днів у порядку часу",
  "ak_scada_no_events": "Подій немає.",
  "ak_scada_event_archive": "Архів подій",
  "ak_scada_cleared_and_historical_records": "Усунені та історичні записи",
  "ak_scada_the_archive_is_empty": "Архів порожній.",
  "ak_scada_sko": "СКО",
  "ak_scada_operational_safety": "опер. безпека",
  "ak_scada_dso_technical_limit": "ОСР / тех. ліміт",
  "ak_scada_manual": "ручне",
  "ak_scada_writing_setpoints_from_the_cabinet_is": "Запис уставок з кабінету ще не ввімкнено: канал до EMS box станцій не введений. У таблиці — фактичні значення з телеметрії; обмеження зараз задаються на станції. Жодна дія з цієї сторінки не змінює роботу обладнання.",
  "ak_scada_stations_power_limits_and_link_status": "{{n}} станцій · потужність, обмеження та звʼязок кожної станції в одному вікні",
  "ak_scada_mw_of": "МВт з",
  "ak_scada_no_data_2": " · без даних: {{n}}",
  "ak_scada_x": " · {{p}} % · {{r}}",
  "ak_scada_link_online_means_data_no_older_than_t": "Звʼязок: «на звʼязку» — дані не старші трьох циклів колектора (Лучки ~1 хв, решта ~5 хв); далі — застарівають; понад 40 хв (Лучки — 15 хв) — немає звʼязку, і потужність такої станції до суми не входить. УЗЕ: + розряд, − заряд.",
  "ak_scada_view_only_mode": "Режим перегляду.",
  "ak_scada_fleet_control": "Керування парком",
  "ak_scada_status_2": "Стан",
  "ak_scada_p_actual_mw": "P факт, МВт",
  "ak_scada_installed_mw": "Встановлена, МВт",
  "ak_scada_load_2": "Завантаження",
  "ak_scada_limit": "Обмеження",
  "ak_scada_inverters": "Інвертори",
  "ak_scada_control_channel": "Канал керування",
  "ak_scada_source_unknown": "джерело невідоме",
  "ak_scada_none": "немає",
  "ak_scada_view_only": "лише перегляд",
  "ak_scada_total_2": "Разом",
};

export default translations;
